import React from "react";
import {Checkbox} from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";


const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;


const AccommodationUnitAutocomplete = ({ accommodationUnits, selectedAccommodationUnits, onSelect=f=>f, textFieldProps, ...props }) => {
    const options = Array.isArray(accommodationUnits) ? accommodationUnits : [];

    return <Autocomplete
        multiple
        value={selectedAccommodationUnits}
        options={options}
        groupBy={(option) => option.accommodation.name}
        isOptionEqualToValue={(o, v) => o.id === v.id && o.type === v.type}
        getOptionLabel={(option) => option.name}
        noOptionsText="Nessun opzione"
        renderOption={(props, option, {selected}) => (
            <li {...props}>
                <Checkbox icon={icon}
                          checkedIcon={checkedIcon}
                          style={{marginRight: 8}}
                          checked={selected}/>
                {option.name}
            </li>
        )}
        onChange={(event, value) => {
            const selectedItems = value.sort(
                (a, b) => a.accommodation.name.localeCompare(b.accommodation.name) || a.name.localeCompare(b.name)
            );
            onSelect(selectedItems);
        }}
        renderInput={(params) => (
            <TextField {...params}
                       label="Unità abitative"
                       fullWidth
                       {...(textFieldProps || {})}
            />
        )}
        {...props}
    />
}

export default AccommodationUnitAutocomplete;